/* @flow */

import React from 'react';

// Styles
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';
import styles from './SponsorsCards.style';

// Utils
import messages from 'src/shared/app/nav/l10n/navigationL10n.json';
import useEvent from 'src/shared/domain/event/hook/useEvent';
import {
  getEventSponsorLogo,
  getEventSponsorLink,
  getEventSponsorName,
  getEventSponsorLogoAltText,
  getEventPlugins,
  getEventSponsorPluginMainNavTitle,
} from '@braindate/domain/lib/event/util';
import SidebarCard from 'src/shared/app/base/component/template/component/sidebar/SidebarCard';
import SponsorItem from './SponsorItem';
import { sponsorshipPlugin as sponsorshipPluginKey } from 'src/shared/app/feature/settings/featureSettings';

// Hooks
import { useIntl } from 'react-intl';

import type { BraindateEventSponsor } from '@braindate/domain/lib/event/type';

const useStyles = createUseThemeStyles(styles);

type Props = {
  eventSponsors: BraindateEventSponsor[],
};

const SponsorsCards = ({ eventSponsors }: Props) => {
  const classes = useStyles();
  const intl = useIntl();

  const event = useEvent();
  const sponsorshipPlugin = getEventPlugins(event)[sponsorshipPluginKey];

  if (!sponsorshipPlugin) return null;

  const sponsorsHeaderTitle = getEventSponsorPluginMainNavTitle(
    sponsorshipPlugin,
    intl.locale,
  );

  const sponsors = (eventSponsors || []).map((sponsor) => ({
    name: getEventSponsorName(sponsor, intl.locale),
    logo: getEventSponsorLogo(sponsor),
    logoAltText: getEventSponsorLogoAltText(sponsor, intl.locale),
    url: getEventSponsorLink(sponsor),
  }));

  if (!sponsors.length) return null;

  return (
    <SidebarCard
      title={
        sponsorsHeaderTitle
          ? sponsorsHeaderTitle
          : intl.formatMessage(messages.meetOurSponsors)
      }
    >
      <div className={classes.sponsorsList}>
        {sponsors.map((sponsor, key) => (
          <SponsorItem sponsor={sponsor} key={`sponsor-${key}`} />
        ))}
      </div>
    </SidebarCard>
  );
};

export default React.memo<Props>(SponsorsCards);
